import React from 'react';
import { AffiliateCard, Callout, CountriesDropdowns, TLDR, ProductCards } from 'src/components';

const markdownCustomComponents = {
  tip: ({ children }) => <Callout type="info">{children}</Callout>,
  warning: ({ children }) => <Callout type="warning">{children}</Callout>,
  'affiliate-card': ({ node, ...props }) => <AffiliateCard {...props} />,
  'product-cards': ({ node, products, ...props }) => {
    // Parse products if it's a string
    const parsedProducts = typeof products === 'string' 
      ? JSON.parse(products) 
      : products;
    
    return <ProductCards products={parsedProducts} {...props} />;
  },
  callout: ({ node, ...props }) => <Callout {...props} />,
  tldr: ({ children }) => <TLDR>{children}</TLDR>,

    'country-sections': ({ children }) => {
      const sectionArray = React.Children.toArray(children);

      const countries = sectionArray
        .filter(
          (child) =>
            React.isValidElement(child) &&
            child.props.flag &&
            child.props.name
        )
        .map((child) => {
          // Keep all children as React nodes, don't stringify
          const content = React.Children.toArray(child.props.children);

          return {
            flag: child.props.flag,
            name: child.props.name,
            content, // React nodes, not string
          };
        });

      return <CountriesDropdowns countries={countries} />;
    },

  'country-section': ({ children }) => <>{children}</>,
};

export default markdownCustomComponents;
